import { getHmlReport } from "lib/api/getHmlReport";
import { useAppStore } from "lib/store/useAppStore";

export default function HmlDownloadBtn({
  upload_id,
  file_name,
  file_type,
  t = "Download HML",
}) {
  const showAlert = useAppStore((s) => s.showAlert);

  if (!upload_id) return null;

  const handleClick = async () => {
    const result = await getHmlReport(upload_id, file_name, file_type);
    if (!result.success) {
      showAlert({
        text: result.message || "Failed to download HML report.",
        messageKey: result.messageKey,
        messageParams: result.messageParams,
        success: false,
        autoClose: true,
      });
    }
  };

  return (
    <button type="button" className="btn-bg-blue" onClick={handleClick}>
      {t}
    </button>
  );
}
